var collapsible_list_component_default = {
  "ltr": "CblGO",
  "rtl": "paVMW",
  "iconContainer": "FDpIj",
  "icon": "oDBn0",
  "isExpanded": "WeSDT",
  "listDimensions": "SzYAd"
};
export {
  collapsible_list_component_default as default
};
//# sourceMappingURL=collapsible-list-component-scss.js.map
